export const configurationFileName = 'shopify.theme.toml'
